module.exports = __webpack_public_path__ + "static/media/Agenda-Day-02.e0d6620c.jpg";